import { getField, updateField } from 'vuex-map-fields';
import LocalOfficeInfo from '../../api/local-office-info';

// initial state
const state = {
    geoLocation: null,
    clinic: null,
    clientToken: '',
    clientCredentials: {
        id: '58d24544-7d73-41e4-886c-4d97f0eea476',
        secret: '9e427304-6f0a-43ce-a488-9a554bc5b02d'
    },
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    getClinicInformation({ commit, rootState }, { Longitude, Latitude, dealerId, clientToken, cb }) {
        LocalOfficeInfo.getClinicInformation((data) => {
            commit('setStateValue', { key: 'clinic', value: data.data[0] });
            if (cb) {
                cb();
            }
        }, { Longitude, Latitude, dealerId, clientToken });
    },
    updateGeoLocation({ commit, rootState }, val) {
        commit('setStateValue', { key: 'geoLocation', value: val });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
